import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { forkJoin, Subject, Subscription, Observable } from "rxjs";
import { AuthorizationService } from "../../shared/services/authorization.service";
import { BudgetCodeService } from "../../shared/services/budget-code.service";
import { TemplateService } from "../../shared/services/template.service";
import { SharedDataService } from "../../shared/sharedData.service";
import * as _ from "lodash";
import { TalentPayrollService } from "../../shared/services/talent-payroll.service";
import { BusinessUnitService } from "../../shared/services/business-unit.service";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import {
    EmitEvent,
    EventBusService,
} from "../../core/services/event-bus.service";
import { LookUpService } from "../../shared/services/lookup.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcModalConfirmation } from "../../shared/component/confirmation/nbc-modal-confirmation.component";
import moment from "moment";
import { ModalCreateTemplateComponent } from "../../dashboard/template/create-template/modal-create-template.component";
import { ModalTimecardTemplateComponent } from "../components/modal-template/modal-timecard-template.component";
import { ModalMultipleTimecardsComponent } from "../components/modal-multi-timecards/modal-multiple-timecards.component";
import { ModalimportTimecardsComponent } from "../components/modal-import-timecards/modal-import-timecards.component";
import { ModalPayTransactionComponent } from "../components/pay-transactions/modal-pay-transaction.component";
import { NbcFileDownloadComponent } from "../../shared/component/nbc-file-download/nbc-file-download.component";
import { SubSink } from "subsink";
import { OnDestroy, HostListener } from "@angular/core";
import { NbcBudgetCodeComponent } from "../../shared/component/nbc-budget-code/nbc-budget-code.component";
import { ComponentCanDeactivate } from "../../core/services/pendingchanges-guard.service";

@Component({
    selector: "timesheet-details",
    templateUrl: "./timesheet-detail.component.html",
    standalone: false
})
export class TimesheetDetailComponent
    implements OnInit, OnDestroy, ComponentCanDeactivate
{
    constructor(
        private lookUpService: LookUpService,
        private budgetCodeService: BudgetCodeService,
        private businessUnitService: BusinessUnitService,
        private authorizationService: AuthorizationService,
        private templateService: TemplateService,
        private talentPayrollService: TalentPayrollService,
        private _sharedDataService: SharedDataService,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private _eventBusService: EventBusService,
        public _modalService: BsModalService,
        private log: NbcLoggerService,
        private _cd: ChangeDetectorRef
    ) {
        //this._cd.detach();
    }
    @ViewChild(NbcFileDownloadComponent) fileDownload;

    subs: SubSink = new SubSink();

    //user info TODO
    loggedInUserTokenList = window.preload.user.allFeatures;

    pageSize = [10, 25, 50, 100];

    selectedBusinessUnit: any = {};
    selectedBuId: any = 0;
    timesheetDetail: any;
    showsortAlert: false;

    daytypes: any = [];
    workStates: any = [];
    employeeTypes: any = [];
    sports: any = [];
    networks: any = [];
    unionCodes: any = [];
    payrollProviders: any = [];
    chargeCodeTypes: any = [];
    defaultConfigs: any = {};
    payrollDefaults: any = [];
    companyCodes: any = [];
    templates: any = [];
    jobCodes: any = [];
    contractCodes: any = [];
    returnPristineCheck: boolean;
    buAccess: any;
    departments: any;
    operationTalentDept = null;
    financePayrollDept = null;
    departmentsWithTimesheets = ["SUBMITTER", "APPROVER"];
    departmentsWithTimecards = ["FINANCE", "PAYROLL"];

    departmentFilterValues: any = [];
    groupUpdateOptions: any = [];
    groupUpdateTimecardOptions: any = [];

    changedListItems: any = [];
    selectedTimesheetListItems: any = [];
    savedOccured = false;

    getQueryContainer() {
        const query = this.talentPayrollService.getPayrollTimesheetQuery(
            this.selectedBuId
        );
        query.batch_id = this.batchId;
        return {
            query: query,
        };
    }

    queryContainer: any;
    timecardsExportQuery: any;
    //master list to captuure bulk/group actions
    jobcodeForBulkUpdate: any = [];
    rateCodes: any = [];
    showBulkUpdateMenu = false;
    bulkFieldSelectedOption: any = {};
    bulkSelectedOption: any = {};
    bulkEntry = null;
    bulkEntryField: any = {};
    groupUpdateOptionList: any = [
        {
            id: 1,
            description: "Add Multiple Timecards",
            key: "multiTimecards",
            access: "addmultipletimecardsbulk.update",
        },
        {
            id: 2,
            description: "Delete Timecard",
            key: "deleteTimecard",
            access: "deletetimecardbulk.update",
        },
        {
            id: 3,
            description: "Clone Timecard",
            key: "cloneTimecard",
            access: "clonetimecardbulk.update",
        },
        {
            id: 4,
            description: "Create Template",
            key: "createTemplate",
            access: "createtemplatebulk.update",
        },
        {
            id: 5,
            description: "Append Template",
            key: "appendTemplate",
            access: "appendtemplatebulk.update",
        },
        {
            id: 6,
            description: "Update",
            key: "updateTimecard",
            access: "updatebulk.update",
        },
        {
            id: 7,
            description: "ResyncContact",
            key: "resyncContact",
            access: "resynccontactbulk.update",
        },
    ];

    //groupUpdateTimecardOptions
    groupUpdateFieldOptions: any = [
        {
            id: 22,
            description: "Dates Worked",
            key: "activityDate",
            access: "datesworkedbulk.update",
        },
        {
            id: 41,
            description: "Day Type",
            key: "dayType",
            access: "daytypebulk.update",
        },
        {
            id: 24,
            description: "Event/Show",
            key: "eventShowName",
            access: "eventshowbulk.update",
        },
        {
            id: 33,
            description: "Sports",
            key: "sport",
            access: "sportsbulk.update",
        },
        {
            id: 25,
            description: "Network",
            key: "network",
            access: "networkbulk.update",
        },
        {
            id: 40,
            description: "Cost Center",
            key: "payrollCostCenter",
            access: "wbsepayrollcostcenterbulk.update",
        },
        {
            id: 21,
            description: "Employee Type",
            key: "employeeType",
            access: "employeetypebulk.update",
        },
        {
            id: 26,
            description: "Work State",
            key: "stateContactWorked",
            access: "workstatebulk.update",
        },
        {
            id: 27,
            description: "Rate (Day)",
            key: "customRate",
            access: "ratebulk.update",
        },
        {
            id: 23,
            description: "Hours Worked",
            key: "hoursWorked",
            access: "hoursworkedbulk.update",
        },
        {
            id: 28,
            description: "WBSE/Cost Center",
            key: "costCenter",
            access: "wbsecostcenterbulk.update",
        },
        {
            id: 29,
            description: "GL Account",
            key: "glAccount",
            access: "glacountbulk.update",
        },
        {
            id: 34,
            description: "Union Code",
            key: "unionCode",
            access: "unioncodebulk.update",
        },
        {
            id: 35,
            description: "Wage Type",
            key: "wageType",
            access: "wagetypebulk.update",
        },
        {
            id: 36,
            description: "Wage Schedule",
            key: "wageschedule",
            access: "wageschedulebulk.update",
        },
        {
            id: 31,
            description: "Payroll Provider",
            key: "payrollProvider",
            access: "payrollproviderbulk.update",
        },
        {
            id: 30,
            description: "TK Contract Code",
            key: "contractCode",
            access: "contractcodebulk.update",
        },
        {
            id: 32,
            description: "Job Code",
            key: "jobCode",
            access: "jobcodebulk.update",
        },
    ];

    queueStatus = [
        { id: "InQueue", description: "In-Queue" },
        { id: "PreQueue", description: "Pre-Queue" },
        { id: "PostQueue", description: "Post-Queue" },
    ];

    searchOptions = [
        { id: "ContactName", description: "Contact Name" },
        { id: "SSO", description: "SSO" },
        { id: "PerNer", description: "PerNer" },
    ];

    costCenterTypeValue = "";

    contactSearchValue = "";

    costCenterType = "";

    contactSearchOption = "";

    WorkFlowId: any;
    batchId: any;

    // @HostListener allows us to also guard against browser refresh, close, etc.
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    @HostListener("window:beforeunload")
    canDeactivate(): boolean {
        if (_.isEmpty(this.changedListItems)) return true;
        else return false;
    }

    configureDefaultPageSize = (pageSizes) => {
        //let pageSizes:any=[]
        const index = _.findIndex(pageSizes, (o: any) => {
            return o.id == this.buAccess.departmentId.toString();
        });
        if (index !== undefined && index >= 0) {
            this.queryContainer.query.pageSize = parseInt(
                pageSizes[index].description
            );
        }
    };

    configureBusinessUnitAccess(access: any) {
        this.buAccess = access;
        this.operationTalentDept = _.includes(
            this.departmentsWithTimesheets,
            this.buAccess.department
        );
        this.financePayrollDept = _.includes(
            this.departmentsWithTimecards,
            this.buAccess.department
        );
    }

    onSortByColumn(datafield) {
        this.log.trace("Sort By Column");
        if (this.queryContainer.query.sortByColumn === datafield) {
            this.queryContainer.query.reverseSort =
                !this.queryContainer.query.reverseSort;
        } else {
            this.queryContainer.query.sortByColumn = datafield;
            this.queryContainer.query.reverseSort = false;
        }
        this.getTimecards();
    }

    onPageNumberClicked($event) {
        this.queryContainer.query.currentPage = $event.page;
        this.getTimecards();
    }

    getData = () => {
        const workStates$ = this.lookUpService.getworkStates();
        const daytypes$ = this.lookUpService.getDayTypes();
        const employeeTypes$ = this.lookUpService.getEmployeeTypes();
        const sports$ = this.lookUpService.getSports();
        const networks$ = this.lookUpService.getNetworks();
        const unionCodes$ = this.lookUpService.getunionCodes();
        const payrollProviders$ = this.lookUpService.getPayrollProviders();
        const chargecodeTypes$ = this.lookUpService.getChargeCodeTypes();
        const defaultConfigs$ = this.lookUpService.getDefaultConfigs();
        const payrollDefaults$ = this.lookUpService.getPayrollDefaults(
            this.selectedBuId
        );
        const defaultPageSize$ = this.lookUpService.getDefaultPageSize();
        const jobcodes$ = this.talentPayrollService.getJobCodes();
        const contractCodes$ = this.talentPayrollService.getContractCodes();

        const companyCodes$ = this.budgetCodeService.getCompanyCodes();
        const buAccess$ = this.authorizationService.getBUAccess(
            this.selectedBuId
        );
        const timesheetTemplates$ = this.templateService.getAllTemplate(
            this.selectedBuId
        );

        //let payrollDefaults$ = this.lookUpService.getPayrollDefaults(this.selectedBusinessUnit.id);
        this.subs.sink = forkJoin(
            daytypes$,
            workStates$,
            employeeTypes$,
            sports$,
            networks$,
            unionCodes$,
            payrollProviders$,
            chargecodeTypes$,
            defaultConfigs$,
            payrollDefaults$,
            defaultPageSize$,
            companyCodes$,
            buAccess$,
            timesheetTemplates$,
            jobcodes$,
            contractCodes$
        ).subscribe(
            ([
                daytypes,
                workStates,
                employeeTypes,
                sports,
                networks,
                unionCodes,
                payrollProviders,
                chargecodeTypes,
                defaultConfigs,
                payrollDefaults,
                defaultPageSize,
                companyCodes,
                access,
                templates,
                jobCodes,
                contractCodes,
            ]) => {
                this.daytypes = daytypes.reference;
                this.workStates = workStates.reference;
                this.employeeTypes = employeeTypes.reference;
                this.sports = sports.reference;
                this.networks = networks.reference;
                this.unionCodes = unionCodes.reference;
                this.payrollProviders = payrollProviders.reference;
                this.chargeCodeTypes = chargecodeTypes.reference;

                this.defaultConfigs = defaultConfigs.reference;
                this.payrollDefaults = payrollDefaults.reference;
                this.configureDefaultPageSize(defaultPageSize.reference);
                this.companyCodes = companyCodes["reference"];
                this.configureBusinessUnitAccess(access.reference);
                this.templates = templates.reference;
                this.jobCodes = jobCodes.reference;
                this.contractCodes = contractCodes.reference;

                const masterData = {
                    daytypes: this.daytypes,
                    workStates: this.workStates,
                    employeeTypes: this.employeeTypes,
                    sports: this.sports,
                    networks: this.networks,
                    unionCodes: this.unionCodes,
                    payrollProviders: this.payrollProviders,
                    chargeCodeTypes: this.chargeCodeTypes,
                    defaultConfigs: this.defaultConfigs,
                    payrollDefaults: this.payrollDefaults,
                    companyCodes: this.companyCodes,
                    jobCodes: this.jobCodes,
                    contractCodes: this.contractCodes,
                    departments: this.departments,
                    buAccess: this.buAccess,
                };

                //emit master data. This is one time load unless page is loaded.
                //this._eventBusService.emit(
                //  new EmitEvent('getData', 'onMasterDataReceived', masterData)
                //);
                this.emitAnEvent("getData", "onMasterDataReceived", masterData);

                this.setDefaultFilterValues();
                this.prepareGridFilters();

                this.prepareBulkUpdateOptions();

                // get initial load timesheet data
                this.getTimecards();
            }
        );
    };

    prepareGridFilters() {
        this.departmentFilterValues = _.map(this.departments, "department");
        this.groupUpdateOptionsList();
        this.validateQueueState();
    }

    prepareBulkUpdateOptions() {
        if (this.jobCodes) {
            this.jobcodeForBulkUpdate = [];
            _.filter(this.jobCodes, (o) => {
              if (o.code === "UNE" || o.code === "UEX" || o.code === "RTS" || o.code === "DT1") {
                    this.jobcodeForBulkUpdate.push(o);
                }
            });
        }
    }

    filterRateCodes() {
        this.rateCodes = _.flatten(
            this.jobCodes
                .filter((jobCode) => {
                    return jobCode.code === this.bulkEntryField.jobCode.code;
                })
                .map((jobCode) => {
                    return jobCode.details;
                })
        );
    }

    validateQueueState() {
        // TODO
        //if ((self.queryContainer.query.workflowStatus.toString() !== self.BuAccess.departmentId.toString()) || (preload.WorkFlowId !== null && preload.WorkFlowId > 0)) {
        //  $("[name='queueStatus']").prop("disabled", true);
        //  $("[name='queueStatus']").addClass("disabled");
        //  $("[name='queueStatus']").val("InQueue");
        //  self.queryContainer.query.queueStatus = "InQueue";
        //  if (preload.WorkFlowId !== null && preload.WorkFlowId > 0) {
        //    if (preload.WorkFlowId === self.BuAccess.departmentId) {
        //      $("[name='queueStatus']").prop("disabled", false);
        //      $("[name='queueStatus']").removeClass("disabled");
        //      $("[name='queueStatus']").val("InQueue");
        //      self.queryContainer.query.queueStatus = "InQueue";
        //    }
        //    else {
        //      $("[name='queueStatus']").addClass("disabled");
        //      $("[name='queueStatus']").val("InQueue");
        //    }
        //  }
        //}
        //else {
        //  $("[name='queueStatus']").prop("disabled", false);
        //  $("[name='queueStatus']").removeClass("disabled");
        //  $("[name='queueStatus']").val("InQueue");
        //  self.queryContainer.query.queueStatus = "InQueue";
        //}
    }

    groupUpdateOptionsList() {
        const keys = Object.keys(this.loggedInUserTokenList);
        this.groupUpdateOptions = _.filter(this.groupUpdateOptionList, (o) => {
            return _.includes(keys, o.access);
        });

        this.groupUpdateTimecardOptions = _.filter(
            this.groupUpdateFieldOptions,
            (o) => {
                return _.includes(
                    Object.keys(this.loggedInUserTokenList),
                    o.access
                );
            }
        );
    }

    setQueueStatus() {
        if (this.WorkFlowId !== null && this.WorkFlowId > 0) {
            if (this.WorkFlowId === this.buAccess.departmentId) {
                this.queryContainer.query.queueStatus = this.queueStatus[0].id;
            } else if (
                this.WorkFlowId >= parseInt(this.buAccess.postQueue, 10)
            ) {
                this.queryContainer.query.queueStatus = this.queueStatus[2].id;
            } else if (
                this.WorkFlowId <= parseInt(this.buAccess.preQueue, 10)
            ) {
                this.queryContainer.query.queueStatus = this.queueStatus[1].id;
            } else {
                this.queryContainer.query.queueStatus = this.queueStatus[0].id;
            }
        } else {
            this.queryContainer.query.queueStatus = this.queueStatus[0].id;
        }
    }

    setDefaultFilterValues() {
        this.queryContainer.query.workflowStatus = this.WorkFlowId
            ? this.WorkFlowId.toString()
            : this.buAccess.departmentId.toString();
        this.setQueueStatus();
        this.costCenterType = "WBSE";
        this.contactSearchValue = "";
        this.costCenterTypeValue = "";
        this.contactSearchOption = this.searchOptions[0].id;
        this.queryContainer.query.eventShowName = "";
        this.queryContainer.query.workState = "";
        this.queryContainer.query.employeeType = "";
        this.queryContainer.query.timecardDateFrom = "";
        this.queryContainer.query.timecardDateTo = "";
        this.queryContainer.query.processedDate = "";
        this.queryContainer.query.sso = "";
        this.queryContainer.query.perNer = "";
        this.queryContainer.query.CostCenter = "";
        this.queryContainer.query.contactName = "";
        this.queryContainer.query.currentPage = 1;
    }

    searchPage(pagesize) {
        this.queryContainer.query.pageSize = pagesize;
        this.getTimecards();
    }

    getTimecards() {
        if (!_.isUndefined(this.batchId)) {
            this.queryContainer.query.batch_id =
                this.batchId !== -1 ? this.batchId : null;
        }
        if (
            this.buAccess.department === "FINANCE" ||
            this.buAccess.department === "PAYROLL"
        ) {
            this.queryContainer.query.batch_id = null;
        }
        this.queryContainer.query.loggedInDept = this.buAccess.departmentId;
        this.queryContainer.query.isApproved =
            this.WorkFlowId === 5 &&
            this.queryContainer.query.workflowStatus === "5"
                ? true
                : false;
        this.queryContainer.query.queueStatus =
            this.queryContainer.query.isApproved === true
                ? "PostQueue"
                : this.queryContainer.query.queueStatus;
        this.queryContainer.query.workflowStatus =
            this.WorkFlowId === 5 &&
            this.queryContainer.query.workflowStatus === "4" &&
            this.queryContainer.query.isApproved
                ? "5"
                : this.queryContainer.query.workflowStatus;

        this.getTimecardsWithQuery();
    }

    onFilterTimecards(query: any) {
        const totalRecords = this.queryContainer.query.totalRecords;
        _.merge(this.queryContainer, query);
        this.queryContainer.query.processedToDate =
            this.queryContainer?.query?.processedDate || "";
        this.queryContainer.query.totalRecords = totalRecords;
        this.getTimecards();
    }

    getTimecardsWithQuery() {
        this.changedListItems = [];

        this.subs.sink = this.talentPayrollService
            .getTimesheetsWithQuery(this.queryContainer.query)
            .subscribe({
                next: (result: any) => {
                    let data: any;
                    this.timecardsExportQuery = _.cloneDeep(
                        this.queryContainer.query
                    );
                    data = result.reference;
                    this.queryContainer.query.pageSize = data.pageSize;
                    this.emitAnEvent(
                        "setSearchQueryPageSize",
                        "setCurrentPageSize",
                        data.pageSize
                    ),
                        this.emitAnEvent(
                            "setSearchQuerySortByCol",
                            "setSortByCol",
                            this.queryContainer.query.sortByColumn
                        ),
                        this.emitAnEvent(
                            "setSearchQueryReverseSort",
                            "setReverseSort",
                            this.queryContainer.query.reverseSort
                        ),
                        this.emitAnEvent(
                            "setGridHeaderQueryContainer",
                            "setGridHeaderQuery",
                            this.timecardsExportQuery
                        ),
                        (this.queryContainer.query.currentPage =
                            data.currentPage);
                    this.queryContainer.query.totalRecords =
                        data.totalRecords == 0
                            ? data.items?.length > 0
                                ? data.items.length
                                : 0
                            : data.totalRecords;
                    this.queryContainer.query.workflowStatus =
                        this.WorkFlowId === 5 &&
                        this.queryContainer.query.workflowStatus === "5"
                            ? "4"
                            : this.queryContainer.query.workflowStatus;
                    //this._eventBusService.emit(
                    //  new EmitEvent('getTimecards()', 'buildGrid', data.items)
                    //);
                    this.emitAnEvent("getTimecards()", "buildGrid", data.items);
                    this.clearCheckboxSelection();
                    //if (isGridRefresh) {
                    //  $scope.$broadcast("buildGrid", self.data.items);

                    //}
                    //else {
                    //  self.payrollTimesheetListItems = self.data.items;
                    //}
                    //if (_.isEmpty(self.data.items)) {
                    //  self.payrollTimesheetListItems = [{ "id": -999 }];
                    //}
                    //self.typesheetType = "vsd";
                    //if ($rootScope.issortedAfterContactAssigned && self.savedOccured) {
                    //  self.showsortAlert = true;
                    //}
                    //else {
                    //  self.showsortAlert = false;
                    //}
                },
                error: (err) =>
                    this.log.showError(
                        "getTalentTimesheet got an error: " + err
                    ),
            });
    }

    addNewTimecard() {
        const args = {
            batchId: this.batchId,
            departmentId: this.buAccess.departmentId,
        };
        let isPristine = false;
        if (_.isEmpty(this.changedListItems)) {
            isPristine = true;
        }

        if (isPristine) {
            this.createNewTimeCard(args);
        } else {
            const msg =
                "You have unsaved changes in unselected timecards which will be discarded.  Are you sure you would like to add new Timecard ?";
            this.showTalentPayrollMessage(
                "scorePay",
                msg,
                true,
                this.createNewTimeCard,
                [args],
                "Continue",
                "Cancel",
                null,
                null
            );
        }
    }

    importNewTimecards() {
        const args = {
            buAccess: this.buAccess,
            sports: this.sports,
            networks: this.networks,
            employeeTypes: this.employeeTypes,
            batchId: this.batchId,
        };
        let isPristine = false;
        if (_.isEmpty(this.changedListItems)) {
            isPristine = true;
        }

        if (isPristine) {
            this.ImportTimeCards(args);
        } else {
            const msg =
                "You have unsaved changes which will be discarded.Are you sure you would like to import Timecard?";
            this.showTalentPayrollMessage(
                "scorePay",
                msg,
                true,
                this.ImportTimeCards,
                [args],
                "Continue",
                "Cancel",
                null,
                null
            );
        }
    }

    createNewTimeCard(args) {
        const timecard = {
            id: -1,
            createdByDepartment: {
                id: args.departmentId,
            },
            timeSheetBatch: {
                id: args.batchId,
            },
        };
        const timecards = [timecard];

        this.subs.sink = this.talentPayrollService
            .upsertTimecards(this.buAccess.businessUnitId, timecards)
            .subscribe({
                next: (result) => {
                    this.queryContainer.query.currentPage = 1;
                    this.getTimecards();
                },
                error: (err) => {
                    this.log.showError(
                        "getTalentTimesheet got an error: " +
                            JSON.stringify(err)
                    );
                },
            });
    }

    assignContact(listItem) {
        listItem.audit.updateDate = new Date();
        const timecards = [listItem];
        if (!_.isEmpty(listItem.contact)) {
            this.subs.sink = this.talentPayrollService
                .assignContact(this.buAccess.businessUnitId, timecards)
                .subscribe({
                    next: (result) => {
                        //this._eventBusService.emit(
                        //  new EmitEvent(
                        //    'details:assignContact',
                        //    'onUpdateOnContactSelect',
                        //    listItem
                        //  )
                        //);
                        this.emitAnEvent(
                            "details:assignContact",
                            "onUpdateOnContactSelect",
                            listItem
                        );
                    },
                    error: (err) => {
                        this.log.error(
                            "getTalentTimesheet got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    onCloneTimecards(timecards) {
        let isPristine = false;
        if (_.isEmpty(this.changedListItems)) {
            isPristine = true;
        }

        if (isPristine) {
            this.cloneTimecard(timecards);
        } else {
            const msg =
                "You have unsaved changes which will be discarded.Are you sure you would like to clone Timecard?";
            this.showTalentPayrollMessage(
                "scorePay",
                msg,
                true,
                this.cloneTimecard,
                [timecards],
                "Continue",
                "Cancel",
                null,
                null
            );
        }
    }

    cloneTimecard(timecards) {
        if (!_.isEmpty(timecards)) {
            this.subs.sink = this.talentPayrollService
                .clone(this.buAccess.businessUnitId, timecards)
                .subscribe({
                    next: (result) => {
                        this.getTimecards();
                    },
                    error: (err) => {
                        this.log.showError(
                            "clone got an error: " + JSON.stringify(err)
                        );
                    },
                });
        }
    }

    /**
     * Resync Contact
     * @memberof score.olympics.controllers.payrollTimesheetController
     * @function resyncContact
     * @public
     */

    resyncContact(timecards) {
        this.log.trace("resyncContact contact");
        if (!_.isEmpty(timecards)) {
            this.subs.sink = this.talentPayrollService
                .resyncContact(this.buAccess.businessUnitId, timecards)
                .subscribe({
                    next: (result) => {
                        this.changedListItems =
                            this.selectedTimesheetListItems = [];
                        this.getTimecards();
                    },
                    error: (err) =>
                        this.log.error(
                            "resyncContact got an error: " + JSON.stringify(err)
                        ),
                });
        } else {
            this.log.showError("please select time card");
        }
    }

    onTimecardDelete(timecards) {
        this.log.trace("delete timecard warning");
        let msg = "Are you sure you want to delete selected Timecards?";
        if (timecards.length === 1) {
            msg = "Are you sure you want to delete this Timecard?";
        }
        const isPageDataPristine = this.checkIfPageDataPristine(
            this.changedListItems,
            timecards
        );

        if (isPageDataPristine) {
            this.showTalentPayrollMessage(
                "scorePay",
                msg,
                true,
                this.deleteTimecard,
                [timecards],
                "Yes",
                "No",
                this.retainItemStatus,
                [timecards, "Delete", false]
            );
        } else {
            const msg =
                "You have unsaved changes in unselected timecards which will be discarded.  Are you sure you would like to delete Timecard ?";
            this.showTalentPayrollMessage(
                "scorePay",
                msg,
                true,
                this.deleteTimecard,
                [timecards],
                "Continue",
                "Cancel",
                this.retainItemStatus,
                [timecards, "Delete", false]
            );
        }
    }

    /*
     * Delete the timecard. Timecards are inactivated
     */
    deleteTimecard(timecards) {
        this.log.trace("delete timecard");

        if (!_.isEmpty(timecards)) {
            this.subs.sink = this.talentPayrollService
                .upsertTimecards(this.buAccess.businessUnitId, timecards)
                .subscribe({
                    next: (result) => {
                        this.log.trace(
                            "deleteTimecard got data" + JSON.stringify(result)
                        );
                        this.changedListItems = [];
                        this.getTimecards();
                    },
                    error: (err) => {
                        this.log.error(
                            "deleteTimecard got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    /**
     * Unlock workflow
     * @param item
     */
    onUnlockTimecard(item) {
        this.log.trace("unlock timecard");
      if (item) {
            item.companyCode = item.companyCode?.description ?? item.companyCode;
            this.subs.sink = this.talentPayrollService
                .unlock(this.buAccess.businessUnitId, item)
                .subscribe({
                    next: (result) => {
                        this.log.trace(
                            "unlock got data" + JSON.stringify(result)
                        );
                        this.getTimecards();
                    },
                    error: (err) => {
                        this.log.showError(
                            "unlock got an error: " + JSON.stringify(err)
                        );
                    },
                });
        }
    }

    //SCOR-16468 - single timecard save
    onDraftSaveTimecard(items) {
        const isPageDataPristine = this.checkIfPageDataPristine(
            this.changedListItems,
            items
        );
        this.onPristineAction(isPageDataPristine, items);
    }

    onPristineAction(isPristine, items) {
        if (isPristine) {
            if (!_.isEmpty(this.changedListItems)) {
                if (!_.isEmpty(items)) {
                    this.retainItemStatus(items, "Save", true);
                }
                this.upsertTimecards(items);
            } else {
                if (!_.isEmpty(items)) {
                    this.retainItemStatus(items, "Save", false);
                }
                this.upsertTimecards(items);
            }
        } else {
            //SCOR-16468 -message updated to replace 'selected timecards' with 'other' to make the message generic for selected and single TC save
            this.showTalentPayrollMessage(
                "scorePay",
                "You have unsaved changes in other timecards which will be discarded. Are you sure you would like to save the selected Timecard?",
                true,
                this.upsertTimecards,
                [items],
                "Save",
                "Cancel",
                this.retainItemStatus,
                [items, "Save", true]
            );
        }
    }

    /*
     * Method is used to any transaction related to Timecard
     */
    upsertTimecards(timecards) {
        if (!_.isEmpty(timecards)) {
            this.subs.sink = this.talentPayrollService
                .upsertTimecards(this.buAccess.businessUnitId, timecards)
                .subscribe({
                    next: (result) => {
                        this.savedOccured = true;
                        this.getTimecards();
                        this.changedListItems = [];
                        this.closeBulkUpdateMenu();
                    },
                    error: (err) => {
                        this.log.error(
                            "getTalentTimesheet got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    onSubmitTimecard(data) {
        this.log.trace("submit timecard");

        if (data.submittedDept === "FINANCE") {
            this.financeOnSubmitPrompt(data.timecards);
        } else if (data.submittedDept === "PAYROLL") {
            this.payrollOnSubmitPrompt(data.timecards);
        } else {
            this.opsTalentOnSubmitPrompt(data.timecards);
        }
    }

    onGlobalSubmitSelected() {
        this.emitAnEvent(
            "grid-details:globalsubmit",
            "onGlobalSubmit",
            this.selectedTimesheetListItems
        );
    }

    draftSaveAllTimecards() {
        this.log.trace("save the draft for selected timesheets");
        const isPageDataPristine = this.checkIfPageDataPristine(
            this.changedListItems,
            this.selectedTimesheetListItems
        );
        //check to see if page data is pristine
        this.onPristineAction(
            isPageDataPristine,
            this.selectedTimesheetListItems
        );
    }

    cancelEdits() {
        this.log.trace("cancel the edits and refresh the grid");
        if (!_.isEmpty(this.changedListItems)) {
            this.showTalentPayrollMessage(
                "scorePay",
                "All unsaved changes will be discarded?",
                true,
                this.getTimecards,
                null,
                "Continue",
                "Cancel",
                null,
                null
            );
        }
    }

    onSplitAftraTimecard(listItem) {
        this.log.trace("split timecards timecard");
        const timecards = [listItem];
        if (!_.isEmpty(timecards)) {
            this.subs.sink = this.talentPayrollService
                .splitAftraTimecard(this.buAccess.businessUnitId, timecards)
                .subscribe({
                    next: (result) => {
                        this.getTimecards();
                    },
                    error: (err) => {
                        this.log.error(
                            "splitAftraTimecard got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        } else {
            alert("Select a TimeCard to Edit");
        }
    }

    onMergeAftraTimecard(timesheets) {
        this.log.trace("merge timecards timecard");
        if (!_.isEmpty(timesheets)) {
            this.subs.sink = this.talentPayrollService
                .upsertTimecards(this.buAccess.businessUnitId, timesheets)
                .subscribe({
                    next: (result) => {
                        this.getTimecards();
                    },
                    error: (err) => {
                        this.log.error(
                            "MergeAftraTimecard got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    onUnauthorizedTimecard(data) {
        const listItem = data.listItem;
        const unauthorizedDept = data.key;
        if (listItem) {
            this.subs.sink = this.talentPayrollService
                .spbStatusUpdate(
                    this.buAccess.businessUnitId,
                    listItem,
                    "Unauthorized"
                )
                .subscribe({
                    next: (result) => {
                        this.getTimecards();
                    },
                    error: (err) => {
                        this.log.error(
                            "onUnauthorizedTimecard got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    spbRejectTimecard(data) {
        const listItem = data.listItem;
        const recjectedDept = data.key;
        if (listItem) {
            this.subs.sink = this.talentPayrollService
                .spbStatusUpdate(
                    this.buAccess.businessUnitId,
                    listItem,
                    "Issued"
                )
                .subscribe({
                    next: (result) => {
                        this.getTimecards();
                    },
                    error: (err) => {
                        this.log.error(
                            "spbRejectTimecard got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    timecardReject(list) {
        this.log.trace("Timecard rejected");
        this.subs.sink = this.talentPayrollService
            .rejectTimecard(this.buAccess.businessUnitId, list)
            .subscribe({
                next: (result) => this.getTimecards(),
                error: (err) => {
                    this.log.error(
                        "spbRejectTimecard got an error: " + JSON.stringify(err)
                    );
                },
            });
    }

    onTimecardRejectWithComments(data) {
        const listItem = data.listItem;
        const recjectedDept = data.key;
        this.returnPristineCheck = this.promUserOnReject(
            listItem,
            recjectedDept
        );
        listItem.DontCloseRejectPopover = this.returnPristineCheck;
    }

    promUserOnReject(timecard, rejectedDept) {
        const isPageDataPristine = this.checkIfPageDataPristine(
            this.changedListItems,
            timecard
        );
        if (isPageDataPristine) {
            this.timecardReject(timecard);
        } else {
            //check whether unsaved changes are on same timecard...
            if (
                this.changedListItems.length === 1 &&
                this.changedListItems[0].id === timecard.id
            ) {
                const msg =
                    "You have unsaved changes in this Timecard which will be discarded. Are you sure you would like to reject Timecard without saving changes?";
                this.showTalentPayrollMessage(
                    "scorePay",
                    msg,
                    true,
                    this.timecardReject,
                    [timecard],
                    "Continue",
                    "Cancel",
                    null,
                    null
                );
            } else {
                const msg =
                    "You have unsaved changes in unselected timecards. Are you sure you would like to reject Timecard without saving changes?";
                this.showTalentPayrollMessage(
                    "scorePay",
                    msg,
                    true,
                    this.timecardReject,
                    [timecard],
                    "Continue",
                    "Cancel",
                    null,
                    null
                );
            }
        }
        return isPageDataPristine;
    }

    /*
     * we need to prompt the user about the action based on payroll provider selected. This method will get trigger only for FINANCE submit or save
     */
    financeOnSubmitPrompt(timecards) {
        const updatedSubmitTimecardModalMessage = this.getSubmitTimecardModalMessage(timecards.length);
        const tcEmployeeTypes = _.map(timecards, "employeeType.id");
        const isPageDataPristine = this.checkIfPageDataPristine(
            this.changedListItems,
            timecards
        );
        const employeeTypeBasedPrompts = [
            {
                employeeTypes: ["DHST", "SNAP", "OTHER", "RECPAY"],
                isGridPristine: false,
                message:
                    `You have unsaved changes which will be discarded.  This action cannot be undone.  ${updatedSubmitTimecardModalMessage}`,
            },
            {
                employeeTypes: ["DHST", "SNAP", "OTHER", "RECPAY"],
                isGridPristine: true,
                message:
                    `This action cannot be undone.  ${updatedSubmitTimecardModalMessage}`,
            },
            {
                employeeTypes: ["PEP", "DH", "FOREIGN", "LOCORP", "STAFF"],
                isGridPristine: true,
                message:
                    `You have unsaved changes which will be discarded. ${updatedSubmitTimecardModalMessage}`,
            },
        ];

        if (
            !_.isEmpty(
                _.intersection(
                    employeeTypeBasedPrompts[0].employeeTypes,
                    tcEmployeeTypes
                )
            )
        ) {
            if (isPageDataPristine) {
                this.showTalentPayrollMessage(
                    "scorePay",
                    employeeTypeBasedPrompts[1].message,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            } else {
                this.showTalentPayrollMessage(
                    "scorePay",
                    employeeTypeBasedPrompts[0].message,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            }

            return;
        } else if (
            !_.isEmpty(
                _.intersection(
                    employeeTypeBasedPrompts[2].employeeTypes,
                    tcEmployeeTypes
                )
            )
        ) {
            if (!isPageDataPristine) {
                this.showTalentPayrollMessage(
                    "scorePay",
                    employeeTypeBasedPrompts[2].message,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            } else {
                this.showTalentPayrollMessage(
                    "scorePay",
                    updatedSubmitTimecardModalMessage,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            }
        } else {
            this.showTalentPayrollMessage(
                "scorePay",
                employeeTypeBasedPrompts[0].message,
                true,
                this.submitTimecards,
                [timecards],
                "Submit",
                "Cancel",
                this.resetTimecards,
                [timecards]
            );
        }
    }

    /*
     * we need to prompt the user about the action based on payroll provider selected. This method will get trigger only for PAYROLL submit or save
     */
    payrollOnSubmitPrompt(timecards) {
        const updatedSubmitTimecardModalMessage = this.getSubmitTimecardModalMessage(timecards.length);
        const tcPayrollProviders = _.map(timecards, "payrollProvider.id");
        const isPageDataPristine = this.checkIfPageDataPristine(
            this.changedListItems,
            timecards
        );
        const payrollBasedPrompts = [
            {
                payrollProviders: ["OTHER"],
                isGridPristine: false,
                message:
                    `You have unsaved changes which will be discarded.  This action cannot be undone.  ${updatedSubmitTimecardModalMessage}`,
            },
            {
                payrollProviders: ["OTHER"],
                isGridPristine: true,
                message:
                    `This action cannot be undone.  ${updatedSubmitTimecardModalMessage}`,
            },
            {
                payrollProviders: ["TK", "SPB"],
                isGridPristine: true,
                message:
                    ` You have unsaved changes which will be discarded.  ${updatedSubmitTimecardModalMessage}`,
            },
        ];

        if (
            !_.isEmpty(
                _.intersection(
                    payrollBasedPrompts[0].payrollProviders,
                    tcPayrollProviders
                )
            )
        ) {
            if (isPageDataPristine) {
                this.showTalentPayrollMessage(
                    "scorePay",
                    payrollBasedPrompts[1].message,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            } else {
                this.showTalentPayrollMessage(
                    "scorePay",
                    payrollBasedPrompts[0].message,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            }

            return;
        } else if (
            !_.isEmpty(
                _.intersection(
                    payrollBasedPrompts[2].payrollProviders,
                    tcPayrollProviders
                )
            )
        ) {
            if (!isPageDataPristine) {
                this.showTalentPayrollMessage(
                    "scorePay",
                    payrollBasedPrompts[2].message,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            } else {
                this.showTalentPayrollMessage(
                    "scorePay",
                    updatedSubmitTimecardModalMessage,
                    true,
                    this.submitTimecards,
                    [timecards],
                    "Submit",
                    "Cancel",
                    this.resetTimecards,
                    [timecards]
                );
            }
        }
    }

    /*This method and prompt is for Operation and Finance Department*/
    opsTalentOnSubmitPrompt(timecards) {
        const updatedSubmitTimecardModalMessage = this.getSubmitTimecardModalMessage(timecards.length);
        const message =
            ` You have unsaved changes which will be discarded.  ${updatedSubmitTimecardModalMessage}`;
        const isPageDataPristine = this.checkIfPageDataPristine(
            this.changedListItems,
            timecards
        );
        if (!isPageDataPristine) {
            this.showTalentPayrollMessage(
                "scorePay",
                message,
                true,
                this.submitTimecards,
                [timecards],
                "Submit",
                "Cancel",
                this.resetTimecards,
                [timecards]
            );
        } else {
            this.showTalentPayrollMessage(
                "scorePay",
                updatedSubmitTimecardModalMessage,
                true,
                this.submitTimecards,
                [timecards],
                "Submit",
                "Cancel",
                this.resetTimecards,
                [timecards]
            );
        }
    }

    getSubmitTimecardModalMessage(length:number){
        return `Are you sure you would like to submit the selected ${length} Timecard(s)?`;
    }

    submitTimecards(timecards) {
        if (!_.isEmpty(timecards)) {
            this.subs.sink = this.talentPayrollService
                .submitTimecards(this.buAccess.businessUnitId, timecards)
                .subscribe({
                    next: (result) => {
                        this.changedListItems = [];
                        this.closeBulkUpdateMenu();
                        if (!_.isEmpty(result)) {
                            this.resetTimecards(timecards);
                            this.showTalentPayrollMessage(
                                "scorePay",
                                result,
                                false,
                                null,
                                null,
                                "OK",
                                "Cancel",
                                null,
                                null
                            );
                        } else {
                            this.getTimecards();
                        }
                    },
                    error: (err) => {
                        this.log.error(
                            "getTalentTimesheet got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    resetTimecards(timecards) {
        if (!_.isEmpty(timecards)) {
            _.forEach(timecards, function (item) {
                if (!_.isEmpty(item.timecardStatus)) {
                    //_.set(modifiedListItems[index], "tpmDepartment.description", lookupObj);
                    const deptStatus = _.find(
                        item.timecardStatus,
                        function (o) {
                            return (
                                o.tpmDepartment.description ===
                                _.toUpper(
                                    _.trim(
                                        item.currentProcessingDepartment
                                            .description
                                    )
                                )
                            );
                        }
                    );
                    deptStatus.isSubmitted = false;
                    deptStatus.submittedBy = null;
                    deptStatus.hasChanged = false;
                    deptStatus.hasSubmitted = false;
                }
            });
        }
    }

    closeBulkUpdateMenu() {
        this.log.trace("closeBulkUpdateMenu");
        this.toggleBulkUpdateMenuBasedOnCheckboxState([]);
        this.resetBulkUpdate();
        // .$broadcast("closeBulkUpdateMenu"); using different method name
        this.clearCheckboxSelection();
    }

    clearCheckboxSelection() {
        this.emitAnEvent(
            "details:closeBulkUpdateMenu",
            "onSelectAllRecordsChange",
            null
        );
        this.emitAnEvent(
            "grid:closeBulkUpdateMenu",
            "onAllRecordsSelected",
            false
        );
    }

    toggleBulkUpdateMenuBasedOnCheckboxState(timesheetListItems) {
        this.log.trace("toggleBulkUpdateMenu");
        this.selectedTimesheetListItems = [];
        _.forEach(timesheetListItems, (item) => {
            if (item.selected) this.selectedTimesheetListItems.push(item);
            if (item.isAftraPayment === "Y") {
                const aftraRecord = _.find(timesheetListItems, {
                    parentTimecard: item.id,
                });
                this.selectedTimesheetListItems.push(aftraRecord);
            }
        });

        this.prepareGridFilters();
        if (this.bulkSelectedOption.key === "resyncContact") {
            this.showBulkUpdateMenu = true;
        } else {
            this.showBulkUpdateMenu =
                this.selectedTimesheetListItems.length > 0;
        }
    }

    openWBSEModal(listId) {
        let modalBudgetCodeRef: BsModalRef;
        const initialState: any = {
            self: this,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        modalBudgetCodeRef = this._modalService.show(
            NbcBudgetCodeComponent,
            modalOptions
        );
        modalBudgetCodeRef.content.onSync.subscribe((wbse) => {
            if (wbse && wbse.code) {
                if (wbse && wbse.code) {
                    this.bulkEntryField.wbseCode = wbse;
                }
            }
        });
    }
    /**
     * Bulk Update
     * @memberof score.olympics.controllers.payrollTimesheetController
     * @function bulkUpdate
     * @returns {}
     * @public
     */
    bulkUpdate() {
        this.log.trace("bulkUpdate");
        if (this.bulkSelectedOption.key === "updateTimecard") {
            let value = {};
            if (this.bulkFieldSelectedOption.key === "activityDate") {
                value = {
                    activityDate: _.toString(this.bulkEntryField.activityDate),
                };
            } else {
                value = this.bulkEntryField;
            }
            const data = {
                listItems: this.selectedTimesheetListItems,
                key: this.bulkFieldSelectedOption.key,
                value: value,
            };
            //this._eventBusService.emit(
            //  new EmitEvent('detail:bulkUpdate', 'bulkUpdate', data)
            //);
            this.emitAnEvent("detail:bulkUpdate", "bulkUpdate", data);
        }
        if (this.bulkSelectedOption.key === "createTemplate") {
            this.createEditTemplate(
                "Create Template",
                true,
                this.bulkSelectedOption.key,
                "Create",
                "Cancel"
            );
        }
        if (this.bulkSelectedOption.key === "appendTemplate") {
            this.createEditTemplate(
                "Append Template",
                true,
                this.bulkSelectedOption.key,
                "Append",
                "Cancel"
            );
        }
        if (this.bulkSelectedOption.key === "multiTimecards") {
            this.createMultipleTimecards();
        }
        if (this.bulkSelectedOption.key === "cloneTimecard") {
            this.onCloneTimecards(this.selectedTimesheetListItems);
        }
        if (this.bulkSelectedOption.key === "resyncContact") {
            this.resyncContact(this.selectedTimesheetListItems);
        } else if (this.bulkSelectedOption.key !== "updateTimecard") {
            const data = {
                listItems: this.selectedTimesheetListItems,
                key: this.bulkSelectedOption.key,
                value: this.bulkEntry,
            };
            //console.log(data,'data');
            //this._eventBusService.emit(
            //  new EmitEvent('detail:bulkUpdate', 'bulkAction', data)
            //);
            this.emitAnEvent("detail:bulkUpdate", "bulkAction", data);
        }
    }

    createEditTemplate(
        title,
        canUpdate,
        bulkSelectedOptionKey,
        confirmText,
        cancelText
    ) {
        let modalConfirmationRef: BsModalRef;

        const initialState: any = {
            self: this,
            modalTitle: title,
            confirmText: confirmText || "Continue",
            cancelText: !canUpdate ? "Close" : cancelText || undefined,
            bulkSelectedOptionKey: bulkSelectedOptionKey,
            templates: this.templates,
            buAccess: this.buAccess,
            timecards: this.selectedTimesheetListItems,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        modalConfirmationRef = this._modalService.show(
            ModalTimecardTemplateComponent,
            modalOptions
        );
        modalConfirmationRef.content.onSync.subscribe((result) => {
            this.log.trace("added Template");
            this.getTimecards();
            this.subs.sink = this.templateService
                .getAllTemplate(this.buAccess.businessUnitId)
                .subscribe({
                    next: (result: any) => (this.templates = result.reference),
                    error: (err) =>
                        this.log.showError(
                            "Unable to load the timesheet template at this time. Please try again later."
                        ),
                });
            this.closeBulkUpdateMenu();
        });
    }

    ImportTimeCards(args) {
        let modalConfirmationRef: BsModalRef;

        const initialState: any = {
            networks: args.networks,
            employeeTypes: args.employeeTypes,
            sports: args.sports,
            buAccess: args.buAccess,
            batchId: args.batchId,
        };

        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
            class: "importModal",
        };

        modalConfirmationRef = this._modalService.show(
            ModalimportTimecardsComponent,
            modalOptions
        );
        modalConfirmationRef.content.onSync.subscribe((result) => {
            this.log.trace("Import timesheet Modal Close");
            this.queryContainer.query.currentPage = 1;
            this.getTimecards();
        });
    }

    createMultipleTimecards() {
        const contacts = _.map(this.selectedTimesheetListItems, "contact");

        let modalConfirmationRef: BsModalRef;

        const initialState: any = {
            batchId: this.batchId,
            buAccess: this.buAccess,
            networks: this.networks,
            workStates: this.workStates,
            employeeTypes: this.employeeTypes,
            sports: this.sports,
            companyCodes: this.companyCodes,
            contactsSelectedForUpdate: contacts,
            daytypes: this.daytypes,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
            class: "multiTimecardModal",
        };

        modalConfirmationRef = this._modalService.show(
            ModalMultipleTimecardsComponent,
            modalOptions
        );
        modalConfirmationRef.content.onSync.subscribe((result) => {
            this.log.trace("multiple timesheet Modal Close");
            this.getTimecards();
        });
    }

    onOpenPayTransaction(listItem, isBulk) {
        let modalPayTransactionRef: BsModalRef;
        if (isBulk) {
            const combinerates = _.uniq(
                _.map(this.selectedTimesheetListItems, (listitem) => {
                    return listitem.aftraAmount ? 0 : 1;
                })
            );
            const rates = _.uniq(
                _.map(this.selectedTimesheetListItems, (listitem) => {
                    return listitem.aftraAmount
                        ? listitem.aftraAmount
                        : listitem.customRate;
                })
            );

            if (combinerates.length === 1 && rates.length === 1) {
                if (combinerates[0] === 0) {
                    listItem.aftraAmount = rates[0];
                } else if (combinerates[0] === 1) {
                    listItem.customRate = rates[0];
                }
            }
        }

        const initialState: any = {
            listItem: listItem,
            isBulk: isBulk,
            payrollDefaultsList: this.payrollDefaults,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        modalPayTransactionRef = this._modalService.show(
            ModalPayTransactionComponent,
            modalOptions
        );
        modalPayTransactionRef.content.onSync.subscribe((result) => {
            this.log.trace("added Payroll Transaction");
            if (isBulk) {
                this.bulkEntryField.payTransactions = result.payTransactions;
            } else {
                this.emitAnEvent(
                    "details:OpenPaytransactionModal",
                    "onUpdatePayTransactions",
                    result
                );
            }
        });
    }

    onContractCodeSelected(dataSelected) {
        this.bulkEntryField.contractCode = dataSelected;
        if (_.has(this.bulkEntryField, "payTransactions")) {
            this.bulkEntryField["payTransactions"] = [];
        }
    }

    resetBulkUpdate() {
        this.bulkFieldSelectedOption = {};
        this.bulkSelectedOption = {};
        this.bulkEntry = null;
        this.bulkEntryField = {};
    }

    exportTimecards() {
        this.log.trace("Export timecards for SPB");

        this.subs.sink = this.talentPayrollService
            .exportTimecards(this.buAccess.businessUnitId)
            .subscribe({
                next: (result) =>
                    this.showTalentPayrollMessage(
                        "scorePay",
                        result,
                        true,
                        this.getTimecards,
                        null,
                        "OK",
                        "",
                        null,
                        null
                    ),
            });
    }

    previewSPBTimecards() {
        this.log.trace("Preview timecards for SPB");
        this.subs.sink = this.talentPayrollService
            .previewTimecards(this.buAccess.businessUnitId)
            .subscribe({
                next: (result) => {
                    if (result.status === 204) {
                        this.showTalentPayrollMessage(
                            "Studio Payroll Preview Report",
                            "There are no data points to export for this report at the moment.",
                            false,
                            null,
                            null,
                            "OK",
                            "",
                            null,
                            null
                        );
                    } else {
                        const fileName = "Studio Payroll Z295 - WC ";
                        this.openInExcel(result.body, fileName);
                    }
                },
                error: (err) =>
                    this.log.error(
                        "getTalentTimesheet got an error: " +
                            JSON.stringify(err)
                    ),
            });
    }

    exportReportTimecards() {
        this.log.trace("Export timecards for SPB");

        this.timecardsExportQuery.currentPage = 1;
        this.timecardsExportQuery.pageSize =
            this.queryContainer.query.totalRecords;
        let timecardsreportname = null;
        if (
            _.indexOf(
                this.departmentsWithTimecards,
                this.buAccess.department
            ) >= 0
        ) {
            timecardsreportname = "Timecards Report";
        } else if (
            _.indexOf(
                this.departmentsWithTimesheets,
                this.buAccess.department
            ) >= 0
        ) {
            timecardsreportname = this.timesheetDetail.name + " Report";
        }

        this.subs.sink = this.talentPayrollService
            .exportreportTimecard(
                this.timecardsExportQuery,
                this.departments[0].businessUnit.displayName,
                timecardsreportname
            )
            .subscribe({
                next: (result) => {
                    if (result.status === 204) {
                        this.showTalentPayrollMessage(
                            "Timecard Export",
                            "There are no data points to export for this report at the moment.",
                            false,
                            null,
                            null,
                            "OK",
                            "",
                            null,
                            null
                        );
                    } else {
                        const fileName = "Timecards Export";
                        this.openInExcel(result.body, fileName);
                    }
                },
                error: (err) =>
                    this.log.error(
                        "export timecards got an error: " + JSON.stringify(err)
                    ),
            });
    }

    onFutureActivitySubmit() {
        const msg =
            "Timecards dated beyond Saturday, " +
            moment().endOf("week").format("MMM DD, YYYY") +
            " cannot be submitted";
        this.log.showError(msg);
    }

    retainItemStatus(items, action, haschanged) {
        if (action === "Delete") {
            _.forEach(items, function (item) {
                item.isActive = true;
            });
        } else if (action === "Submit" || "Save") {
            _.forEach(items, function (item) {
                if (!_.isEmpty(item.timecardStatus)) {
                    const deptStatus = _.find(item.timecardStatus, (o) => {
                        return (
                            o.tpmDepartment.description ===
                            _.toUpper(
                                _.trim(
                                    item.currentProcessingDepartment.description
                                )
                            )
                        );
                    });
                    deptStatus.isSubmitted = false;
                    deptStatus.submittedBy = null;
                    deptStatus.hasChanged = haschanged;
                    deptStatus.hasSubmitted = false;
                }
            });
        }
    }

    showBulkActionFailureMsg(data) {
        const msg = data.msg,
            listItems = data.listItems;

        let failedItems = "";
        if (!_.isEmpty(listItems)) {
            failedItems = "<ul>";

            _.forEach(listItems, function (item) {
                const activityDate = !item.activityDate
                    ? ""
                    : item.activityDate;
                failedItems +=
                    "<li> <span>" +
                    item.contact.fullName +
                    " - " +
                    activityDate +
                    "</span></li>";
            });
            failedItems += "</ul>";
        }

        this.showTalentPayrollMessage(
            "scorePay",
            msg + "<br/>" + failedItems,
            false,
            null,
            null,
            "Ok",
            null,
            null,
            null
        );
    }

    showInvalidContactAlert() {
        const msg =
            "Do not proceed in crewing this contact; please contact Human Resources.";
        this.log.showError(msg);
    }

    /*
     * Method compares between dirty items and submitted/saved items.
     */
    checkIfPageDataPristine(sourceToCompare, targetToGetCompared) {
        let isPristine = false;
        if (_.isEmpty(sourceToCompare)) {
            isPristine = true;
        } else {
            const changedValuesButNotSelected = _.differenceBy(
                sourceToCompare,
                targetToGetCompared,
                "id"
            );

            if (_.isEmpty(changedValuesButNotSelected)) {
                isPristine = true;
            }
        }
        return isPristine;
    }

    showTalentPayrollMessage(
        title,
        message,
        canUpdate,
        callback,
        args,
        confirmText,
        cancelText,
        cancelCallback,
        cancelargs
    ) {
        let modalConfirmationRef: BsModalRef;

        const initialState: any = {
            self: this,
            modalTitle: title,
            modalMessage: message,
            confirmText: confirmText || "Continue",
            cancelText: !canUpdate ? "Close" : cancelText || undefined,
            hideConfirm: !canUpdate,
        };
        const modalOptions = {
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        modalConfirmationRef = this._modalService.show(
            NbcModalConfirmation,
            modalOptions
        );
        modalConfirmationRef.content.onAffirmation.subscribe((result) => {
            callback.apply(this, args);
        });
        modalConfirmationRef.content.onRejection.subscribe((result) => {
            cancelCallback.apply(this, cancelargs);
        });
    }

    getBuAccess() {
        this.subs.sink = this.authorizationService
            .getBUAccess(this.selectedBuId)
            .subscribe({
                next: (result) => {
                    this.buAccess = result.reference;
                    this._sharedDataService.setBuAccess(this.buAccess);
                },
            });
    }

    getTimesheets() {
        if (this.batchId) {
            this.subs.sink = this.talentPayrollService
                .getTimesheets(this.batchId)
                .subscribe({
                    next: (result) => {
                        this.timesheetDetail = result.reference;
                    },
                    error: (err) => {
                        this.log.error(
                            "getTalentTimesheet got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    openInExcel(data, fileName) {
        const d = moment(new Date()).format("MM-DD-yyyy");
        this.fileDownload.fileName = fileName + "-" + d;
        this.fileDownload.fileType = "excel";
        this.fileDownload.data = data;
        this.fileDownload.download();
    }

    emitAnEvent(source, target, data) {
        this._eventBusService.emit(new EmitEvent(source, target, data));
    }
    getParams(route) {
        return {
            ...route.params,
            ...route.children.reduce(
                (acc, child) => ({ ...this.getParams(child), ...acc }),
                {}
            ),
        };
    }

    subscribeEventHandlers() {
        const params = this.getParams(this.router.routerState.snapshot.root);

        if (params["buid"]) {
            this.selectedBuId = params["buid"];
            this.getBusinessUnitDepartments();
            this.getBuAccess();
        }
        if (params["wrfid"]) {
            this.WorkFlowId = params["wrfid"];
        }
        if (params["batchid"]) {
            this.batchId = params["batchid"];
            this.getTimesheets();
        }

        this.subs.sink = this._eventBusService.on(
            "setChanged",
            (data) => (this.changedListItems = data)
        );

        this.subs.sink = this._eventBusService.on("addNewTimecard", () =>
            this.addNewTimecard()
        );

        this.subs.sink = this._eventBusService.on("importNewTimecard", () =>
            this.importNewTimecards()
        );

        this.subs.sink = this._eventBusService.on(
            "showInvalidContactAlert",
            () => this.showInvalidContactAlert()
        );

        this.subs.sink = this._eventBusService.on("assignContact", (listItem) =>
            this.assignContact(listItem)
        );

        this.subs.sink = this._eventBusService.on(
            "onCloneTimecards",
            (listItems) => this.onCloneTimecards(listItems)
        );

        this.subs.sink = this._eventBusService.on(
            "onTimecardDelete",
            (listItems) => this.onTimecardDelete(listItems)
        );

        this.subs.sink = this._eventBusService.on(
            "showBulkActionFailureMsg",
            (msgParams) => this.showBulkActionFailureMsg(msgParams)
        );

        this.subs.sink = this._eventBusService.on(
            "onUnlockTimecard",
            (listItem) => this.onUnlockTimecard(listItem)
        );

        this.subs.sink = this._eventBusService.on(
            "onFutureActivitySubmit",
            () => this.onFutureActivitySubmit()
        );

        this.subs.sink = this._eventBusService.on("onSubmitTimecard", (data) =>
            this.onSubmitTimecard(data)
        );

        this.subs.sink = this._eventBusService.on(
            "toggleBulkUpdateMenuBasedOnCheckboxState",
            (selectedItems) =>
                this.toggleBulkUpdateMenuBasedOnCheckboxState(selectedItems)
        );

        this.subs.sink = this._eventBusService.on(
            "onDraftSaveTimecard",
            (itemsToSave) => this.onDraftSaveTimecard(itemsToSave)
        );

        this.subs.sink = this._eventBusService.on(
            "onSplitAftraTimecard",
            (listItem) => this.onSplitAftraTimecard(listItem)
        );

        this.subs.sink = this._eventBusService.on(
            "onMergeAftraTimecard",
            (timesheets) => this.onMergeAftraTimecard(timesheets)
        );

        this.subs.sink = this._eventBusService.on(
            "onUnauthorizedTimecard",
            (data) => this.onUnauthorizedTimecard(data)
        );

        this.subs.sink = this._eventBusService.on("spbRejectTimecard", (data) =>
            this.spbRejectTimecard(data)
        );

        this.subs.sink = this._eventBusService.on("onSortByColumn", (data) =>
            this.onSortByColumn(data)
        );

        this.subs.sink = this._eventBusService.on(
            "onOpenPayTransaction",
            (listItem) => this.onOpenPayTransaction(listItem, false)
        );

        this.subs.sink = this._eventBusService.on("timecardReject", (data) =>
            this.onTimecardRejectWithComments(data)
        );

        this.subs.sink = this._eventBusService.on(
            "onFilterTimecards",
            (query) => this.onFilterTimecards(query)
        );
    }
    getBusinessUnitDepartments() {
        this.subs.sink = this.businessUnitService
            .getBuDept(this.selectedBuId)
            .subscribe({
                next: (result) => {
                    this.departments = result.reference;
                },
            });
    }

    showContactSearchFlyout() {
      //this.contactFlyoverSubject.next();
      this._sharedDataService.setFlyOverStatus(""); //TODO: Revisit
    }

    @HostListener("document:scroll", ["$event"])
    @HostListener("document:mouseover", ["$event"])
    onWindowScroll($event) {
        if (this.buAccess?.department === "SUBMITTER") {
            const staticsection: HTMLElement =
                document.querySelector(".static-area");
            const sourceStickyHeader: HTMLElement =
                document.querySelector(".hiddenGridHeader");
            const source: HTMLElement =
                document.querySelector(".grid-header-row");
            const nbcAlert: HTMLElement = document.querySelector("nbc-alert");
            const alertCount = nbcAlert?.children?.item(0)?.childNodes?.length;
            const Sourcechildren = source?.children;
            const headerWidth = [];

            if (this?.queryContainer?.query?.totalRecords < 7) {
                if (sourceStickyHeader) {
                    if (sourceStickyHeader.classList.contains("showSticky")) {
                        sourceStickyHeader.style.position = "static";
                        sourceStickyHeader.style.visibility = "collapse";
                        sourceStickyHeader.classList.remove("showSticky");
                    } else {
                        sourceStickyHeader.className += " showSticky";
                    }

                    if (staticsection) {
                        staticsection.classList.remove("fixed");
                    }
                }
                return;
            }

            let mTop = -198;
            if (alertCount >= 2) {
                // mTop = mTop + (alertCount - 1) * 73;
                if (window.scrollY >= 173) {
                    mTop = -135;
                } else {
                    mTop = window.scrollY + -198;
                }
            }

            if (staticsection) {
                if (window.scrollY >= 173) {
                    if (!staticsection.classList.contains("fixed"))
                        staticsection.className += " fixed";

                    if (sourceStickyHeader) {
                        if (
                            !sourceStickyHeader.classList.contains("showSticky")
                        )
                            sourceStickyHeader.className += " showSticky";
                    }
                } else {
                    staticsection.classList.remove("fixed");
                }
            }
            let columnwidth = 272;
            let colcount = 0;
            if (sourceStickyHeader) {
                if (window.scrollY >= 173) {
                    sourceStickyHeader.style.position = "fixed";
                    sourceStickyHeader.style.visibility = "visible";
                    sourceStickyHeader.style.marginTop = mTop + "px";
                    sourceStickyHeader.style.marginLeft = "-272px";
                    sourceStickyHeader.style.zIndex = "1000";

                    let headerColCount = 0;
                    _.each(Sourcechildren, (cole: Element) => {
                        const htmlElementCole = cole as HTMLElement;
                        if (headerColCount >= 3) {
                            headerWidth.push(htmlElementCole.offsetWidth);
                        }
                        headerColCount++;
                    });

                    let index = 0;
                    _.each(sourceStickyHeader?.children, (col: Element) => {
                        const htmlElementCol = col as HTMLElement;
                        if (colcount >= 3) {
                            htmlElementCol.style.position = "fixed";
                            htmlElementCol.style.display = "flex";
                            htmlElementCol.style.margin =
                                "0px 0px 0px " + columnwidth + "px";
                            htmlElementCol.style.width =
                                "" + headerWidth[index] + "px";
                            htmlElementCol.style.alignItems = "center";
                            columnwidth += htmlElementCol.offsetWidth;
                            index++;
                        }
                        colcount++;
                    });
                } else {
                    _.each(sourceStickyHeader?.children, (col: any) => {
                        col.classList.remove("fixed");
                        col.style = "";
                    });
                    sourceStickyHeader.style.position = "static";
                    sourceStickyHeader.style.visibility = "collapse";
                }
            }
        }
    }

    ngOnInit() {
        //this is for temp. purpose where we are enabling change detection for 25 seconds on initial load
        // next step to be found out!
        //let interval = setInterval(() => this._cd.detectChanges(), 500);

        //    setTimeout(() => clearInterval(interval), 25000);
        this.loggedInUserTokenList = window.preload.user.allFeatures;

        this.subscribeEventHandlers();
        this.queryContainer = this.getQueryContainer();
        this.getData();
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
